const MODAL_NAME_PRODUCT = 'товара'
const MODAL_NAME_CATEGORY = 'категории'
const MODAL_NAME_ONLINE_ORDER = 'интернет заказа'
const MODAL_NAME_SALE = 'продажи'
const MODAL_NAME_USERS = 'нового сотрудника'
const MODAL_REPAIR = 'ремонта'

const PAGE_NAME_AUTH = 'Авторизация - Master CRM'
const PAGE_NAME_DASHBOARD = 'Главная'
const PAGE_NAME_PRODUCT = 'Товары'
const PAGE_NAME_CATEGORY = 'Категории товаров'
const PAGE_NAME_ONLINE_ORDER = 'Интернет заказы'
const PAGE_NAME_USERS = 'Сотрудники'
const PAGE_NAME_SALE = 'Все продажи'
const PAGE_NAME_SALE_RETURNED = 'Возвраты'
const PAGE_NAME_SALE_USERS = 'Продажи сотрудников'
const PAGE_NAME_SALE_STATISTIC = 'Статистика продаж'
const PAGE_NAME_BAR_CODES = 'Штрих-коды товаров'
const PAGE_NAME_WORKING_SHIFT = 'Рабочие смены'
const PAGE_NAME_CASH_OPERATION = 'Операции по кассе'
const PAGE_NAME_INVENTORY = 'Инвентаризация'
const PAGE_HISTORY = 'История'
const PAGE_SETTINGS = 'Настройки'
const PAGE_REPAIR = 'Ремонт'
const PAGE_USER_SETTINGS = 'Настройки пользователя'

const NAMES = {
  activePage: {
    'saleUsers': 'sale',
    'saleStatistic': 'sale'
  },
  modalNames: {
    'product': MODAL_NAME_PRODUCT,
    'category': MODAL_NAME_CATEGORY,
    'onlineOrder': MODAL_NAME_ONLINE_ORDER,
    'sale': MODAL_NAME_SALE,
    'users': MODAL_NAME_USERS,
    'repair': MODAL_REPAIR
  },
  pageNames: {
    'auth': PAGE_NAME_AUTH,
    'dashboard': PAGE_NAME_DASHBOARD,
    'product': PAGE_NAME_PRODUCT,
    'category': PAGE_NAME_CATEGORY,
    'onlineOrder': PAGE_NAME_ONLINE_ORDER,
    'users': PAGE_NAME_USERS,
    'sale': PAGE_NAME_SALE,
    'saleReturned': PAGE_NAME_SALE_RETURNED,
    'saleUsers': PAGE_NAME_SALE_USERS,
    'saleStatistic': PAGE_NAME_SALE_STATISTIC,
    'barCodes': PAGE_NAME_BAR_CODES,
    'workingShift': PAGE_NAME_WORKING_SHIFT,
    'cashOperation': PAGE_NAME_CASH_OPERATION,
    'inventory': PAGE_NAME_INVENTORY,
    'history': PAGE_HISTORY,
    'settings': PAGE_SETTINGS,
    'userSettings': PAGE_USER_SETTINGS,
    'repair': PAGE_REPAIR
  }
}

export default NAMES